import request from "@/utils/request";
import qs from "qs";
// 查询结算资料
export function xcCompanyRep(params) {
  return request({
    url: "/api/xcCompanyRep" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}


// 报告下载
export function queryReportFile(id) {
  return request({
    url: 'cus/queryReportFile/' + id,
    method: 'Get',
  })
}

// 改变报告名称 获取文件地址
export function channgeFileName(data) {
  return request({
    url: 'cus/channgeFileName',
    method: 'post',
    data
  })
}

// 渠道新增价格码
export function xcCompanyRepoCode(data) {
  return request({
    url: 'api/xcCompanyRepoCode',
    method: 'post',
    data
  })
}

// 根据价格码id获取海报
export function genPricePost(id) {
  return request({
    url: "/api/genPricePost/" + id,
    method: "get",
  });
}

// 查询渠道的价格码
export function getXcCompanyRepoCode(params) {
  return request({
    url: "/api/xcCompanyRepoCode" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}

// 获取价格码配置
export function getRepoCodeConfig(id) {
  return request({
    url: "/api/getRepoCodeConfig/" + id,
    method: "get",
  });
}

// 修改更新价格码内容
export function putRepoCodeConfig(data) {
  return request({
    url: "/api/xcCompanyRepoCode",
    method: "put",
    data
  });
}

// 设置价格码为默认
export function setDefault(id) {
  return request({
    url: "/api/setDefault/" + id,
    method: "get",
  });
}

// 获取产品id
export function searchIdByProductNameAndDepName(name) {
  return request({
    url: "api/searchIdByProductNameAndDepName/" + name,
    method: "Get",
  });
}

// 获取产品进件码
export function getProductApplyCode(data) {
  return request({
    url: "api/xcCompanyRep/genApplyEwm",
    method: 'post',
    data
  });
}

// 获取渠道默认价格码id
export function queryDefRepoList(id) {
  return request({
    url: "cus/queryDefRepoList/" + id,
    method: "Get",
  });
}


// ai解读海报接口>>>>>>>>>>>>>>>
// ai测试环境接口 http://localhost:9002
// ai正式环境接口 https://aiapi.xchengtech.cn/
const AI_API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:9002'
  : 'https://aiapi.xchengtech.cn';

// 当订单状态为0，代表未生成解读报告，则调用一次 进行生成
export function companyRepoAnalyze(reportId) {
  return request({
    url: AI_API_BASE + "/companyRepoAnalyze/" + reportId,
    method: 'get',
  });
}

// 查询解读报告生成情况
export function companyRepoAnalyzeGet(reportId) {
  return request({
    url: AI_API_BASE + "/companyRepoAnalyze/get/" + reportId,
    method: 'get',
  });
}

// 绩效会 获取企业报告海报
export function genCompanyRepoPosts() {
  return request({
    url: "api/genCompanyRepoPosts",
    method: 'get',
  });
}


// WEBPACK FOOTER //
// ./src/api/companyRep.js